import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Instagram, ExternalLink } from 'lucide-react';
export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const instagramUrl = 'https://www.instagram.com/veranova_klussen?igsh=MTY5MmppcGx2ZmN2OQ==';
  return <footer className="bg-gray-900 text-white" data-id="element-475">
      {/* Main Footer Content */}
      <div className="bg-gradient-to-b from-gray-900 to-gray-950" data-id="element-476">
        <div className="container mx-auto px-6 py-16" data-id="element-477">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16" data-id="element-478">
            {/* Column 1: About */}
            <div data-id="element-479">
              <div className="mb-8" data-id="element-480">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/j38SAssrtskzGcKewqUYrE/Veranova_Logo.png" alt="Veranova" className="h-12 mb-6 brightness-125" data-id="element-481" />
                <p className="text-gray-300 leading-relaxed" data-id="element-482">
                  Specialist in het ontwerpen en plaatsen van luxe veranda's op
                  maat. Wij transformeren uw buitenruimte in een stijlvolle
                  leefomgeving met hoogwaardige materialen en vakmanschap.
                </p>
              </div>
              {/* Social Media */}
              <div className="mt-8" data-id="element-483">
                <h4 className="text-lg font-semibold mb-4 text-white flex items-center" data-id="element-484">
                  <div className="w-6 h-[2px] bg-[#CDA735] mr-3" data-id="element-485"></div>
                  Volg ons
                </h4>
                <div className="flex space-x-4" data-id="element-486">
                  <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="bg-[#CDA735]/10 hover:bg-[#CDA735]/20 p-3 rounded-full text-[#CDA735] transition-all hover:scale-105 duration-300" aria-label="Volg ons op Instagram" data-id="element-487">
                    <Instagram size={20} data-id="element-488" />
                  </a>
                  <a href="https://wa.me/31625023378" target="_blank" rel="noopener noreferrer" className="bg-[#CDA735]/10 hover:bg-[#CDA735]/20 p-3 rounded-full text-[#CDA735] transition-all hover:scale-105 duration-300" aria-label="Stuur ons een WhatsApp bericht" data-id="element-489">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/on5ADKbG5v5f83NALg5Mhn/pngimg.com_-_whatsapp_PNG21_-_Bewerkt.png" alt="WhatsApp" className="w-5 h-5" data-id="element-490" />
                  </a>
                </div>
              </div>
            </div>
            {/* Column 2: Contact */}
            <div data-id="element-491">
              <h4 className="text-lg font-semibold mb-6 text-white flex items-center" data-id="element-492">
                <div className="w-6 h-[2px] bg-[#CDA735] mr-3" data-id="element-493"></div>
                Contact
              </h4>
              <ul className="space-y-5" data-id="element-494">
                <li className="flex items-center gap-3 group" data-id="element-495">
                  <div className="bg-[#CDA735]/10 p-2.5 rounded-full text-[#CDA735] group-hover:bg-[#CDA735]/20 transition-colors" data-id="element-496">
                    <Phone size={18} data-id="element-497" />
                  </div>
                  <div data-id="element-498">
                    <p className="text-gray-400 text-sm mb-1" data-id="element-499">Telefoonnummer</p>
                    <a href="tel:+31625023378" className="text-white hover:text-[#CDA735] transition-colors" data-id="element-500">
                      +31 (0)6 250 233 78
                    </a>
                  </div>
                </li>
                <li className="flex items-center gap-3 group" data-id="element-501">
                  <div className="bg-[#CDA735]/10 p-2.5 rounded-full text-[#CDA735] group-hover:bg-[#CDA735]/20 transition-colors" data-id="element-502">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/on5ADKbG5v5f83NALg5Mhn/pngimg.com_-_whatsapp_PNG21_-_Bewerkt.png" alt="WhatsApp" className="w-[18px] h-[18px]" data-id="element-503" />
                  </div>
                  <div data-id="element-504">
                    <p className="text-gray-400 text-sm mb-1" data-id="element-505">WhatsApp</p>
                    <a href="https://wa.me/31625023378" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#CDA735] transition-colors" data-id="element-506">
                      +31 (0)6 250 233 78
                    </a>
                  </div>
                </li>
                <li className="flex items-center gap-3 group" data-id="element-507">
                  <div className="bg-[#CDA735]/10 p-2.5 rounded-full text-[#CDA735] group-hover:bg-[#CDA735]/20 transition-colors" data-id="element-508">
                    <Mail size={18} data-id="element-509" />
                  </div>
                  <div data-id="element-510">
                    <p className="text-gray-400 text-sm mb-1" data-id="element-511">E-mailadres</p>
                    <a href="mailto:info@veranovaklussen.nl" className="text-white hover:text-[#CDA735] transition-colors" data-id="element-512">
                      info@veranovaklussen.nl
                    </a>
                  </div>
                </li>
              </ul>
            </div>
            {/* Column 3: Quick Links */}
            <div data-id="element-513">
              <h4 className="text-lg font-semibold mb-6 text-white flex items-center" data-id="element-514">
                <div className="w-6 h-[2px] bg-[#CDA735] mr-3" data-id="element-515"></div>
                Snelle links
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4" data-id="element-516">
                <Link to="/producten" className="text-gray-300 hover:text-[#CDA735] transition-colors flex items-center" data-id="element-517">
                  <div className="w-1.5 h-1.5 bg-[#CDA735] rounded-full mr-2.5" data-id="element-518"></div>
                  Onze producten
                </Link>
                <Link to="/over-ons" className="text-gray-300 hover:text-[#CDA735] transition-colors flex items-center" data-id="element-519">
                  <div className="w-1.5 h-1.5 bg-[#CDA735] rounded-full mr-2.5" data-id="element-520"></div>
                  Over ons
                </Link>
                <Link to="/offerte-aanvragen" className="text-gray-300 hover:text-[#CDA735] transition-colors flex items-center" data-id="element-521">
                  <div className="w-1.5 h-1.5 bg-[#CDA735] rounded-full mr-2.5" data-id="element-522"></div>
                  Offerte aanvragen
                </Link>
                <Link to="/adviesgesprek" className="text-gray-300 hover:text-[#CDA735] transition-colors flex items-center" data-id="element-523">
                  <div className="w-1.5 h-1.5 bg-[#CDA735] rounded-full mr-2.5" data-id="element-524"></div>
                  Adviesgesprek
                </Link>
                <a href={instagramUrl} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#CDA735] transition-colors flex items-center" data-id="element-525">
                  <div className="w-1.5 h-1.5 bg-[#CDA735] rounded-full mr-2.5" data-id="element-526"></div>
                  Recente projecten
                </a>
                <Link to="/contact" className="text-gray-300 hover:text-[#CDA735] transition-colors flex items-center" data-id="element-527">
                  <div className="w-1.5 h-1.5 bg-[#CDA735] rounded-full mr-2.5" data-id="element-528"></div>
                  Contact
                </Link>
              </div>
              <div className="mt-10 bg-black/20 rounded-lg p-5 border border-gray-800" data-id="element-529">
                <h5 className="font-medium text-white mb-3 flex items-center" data-id="element-530">
                  <div className="w-4 h-[2px] bg-[#CDA735] mr-2" data-id="element-531"></div>
                  Werkdagen
                </h5>
                <ul className="space-y-2" data-id="element-532">
                  <li className="flex justify-between text-sm" data-id="element-533">
                    <span className="text-gray-400" data-id="element-534">Maandag - Vrijdag</span>
                    <span className="text-gray-300" data-id="element-535">09:00 - 17:30</span>
                  </li>
                  <li className="flex justify-between text-sm" data-id="element-536">
                    <span className="text-gray-400" data-id="element-537">Zaterdag</span>
                    <span className="text-gray-300" data-id="element-538">10:00 - 16:00</span>
                  </li>
                  <li className="flex justify-between text-sm" data-id="element-539">
                    <span className="text-gray-400" data-id="element-540">Zondag</span>
                    <span className="text-gray-300" data-id="element-541">Gesloten</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Internal links section - add to the existing Footer component */}
      
      {/* Copyright Bar */}
      <div className="bg-black/50 backdrop-blur-sm" data-id="element-542">
        <div className="container mx-auto px-6 py-4" data-id="element-543">
          <div className="flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm" data-id="element-544">
            <div className="mb-4 md:mb-0" data-id="element-545">
              <p data-id="element-546">
                © 2025-{currentYear} Veranova Klussen. Alle rechten
                voorbehouden.
              </p>
            </div>
            <div className="flex items-center" data-id="element-547">
              <span className="mr-2" data-id="element-548">Website door</span>
              <a href="https://radux.nl" target="_blank" rel="noopener noreferrer" className="text-[#CDA735] hover:text-white transition-colors flex items-center" data-id="element-549">
                Radux Digital Agency
                <ExternalLink size={12} className="ml-1" data-id="element-550" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};